import { createApiClient } from "@/utils/httpClient";
import RequestError from "@/types/utils/RequestError";

const enriquecimentoApi = createApiClient({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
});

interface RegistrarHistoricoParams {
  usuario_id?: number | null;
  campo_alterado: string;
  origem_alteracao: string;
  valor_anterior?: string | null;
  valor_novo?: string | null;
}

export const registrarMultiplosHistoricos = async (
  alteracoes: RegistrarHistoricoParams[],
): Promise<void> => {
  try {
    await enriquecimentoApi.post("v1/enrichment/history", {
      alteracoes,
    });
  } catch (err) {
    const error = err as RequestError;
    console.error("Erro ao registrar múltiplos históricos:", error);
  }
};
